module.exports = __webpack_public_path__ + "7d190ec6d9abbfc34e05300d71f2ef2f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/dff.png
// module id = +CYy
// module chunks = 0